import { render, staticRenderFns } from "./GfContributions.vue?vue&type=template&id=731fbb3a"
import script from "./GfContributions.vue?vue&type=script&lang=js"
export * from "./GfContributions.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports